import React from 'react';
import { inject, observer } from 'mobx-react';
import Form from "../../Form";

@inject('stationStore', 'parameterStore')
@observer
export default class AnalysisDataDownload extends React.Component {

  render() {
    const {
      downloadCSVData,
      downloadHierData,
      ready
    } = this.props;

    if (ready)
      return <Form>
        <button disabled={!ready} onClick={(e) => {e.preventDefault(); downloadCSVData("CSV");}}>Export as CSV</button>
        <button disabled={!ready} onClick={downloadHierData}>Export as xlsx</button>
        <button disabled={!ready} onClick={(e) => {e.preventDefault(); downloadCSVData("PDF");}}>Export as PDF</button>
      </Form>;
    else
      return <span>Processing . . .</span>
  }
}


// WEBPACK FOOTER //
// ./src/components/Analysis/Data/AnalysisDataDownload.js